import { Injectable } from '@angular/core';
import { TwitterQueueEnum } from 'src/app/shared/strategies/shared/twitter-queue.enum';

import { SiteTypeEnum } from '../../enums';
import { QuickRepliesElementsConfiguration } from '../../models';
import { StrategyAbstractService } from '../strategy-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class TwitterService extends StrategyAbstractService {
  constructor() {
    super();
  }

  getType(): number {
    return 2; // alcmeon.db.Sites.TYPE_TWITTER
  }
  getTypeString(): string {
    return SiteTypeEnum.Twitter;
  }
  getAllTasksTypes(): number[] {
    return [TwitterQueueEnum.PRIVATE, TwitterQueueEnum.MENTION];
  }

  getPrivateTaskTypes(): number[] {
    return [TwitterQueueEnum.PRIVATE];
  }

  getPublicTaskTypes(): number[] {
    return [TwitterQueueEnum.MENTION];
  }

  getPublicRepliesTaskTypes(): number[] {
    return [TwitterQueueEnum.PUBLIC_REPLIES];
  }

  canHaveSurveys(): boolean {
    return true;
  }

  getTaskTypesGroups() {
    return [
      {
        translateKey: 'twitter/dm',
        taskTypes: [TwitterQueueEnum.PRIVATE],
      },
      {
        translateKey: 'twitter/mentions',
        taskTypes: [TwitterQueueEnum.MENTION],
      },
      {
        translateKey: 'twitter/public-replies',
        taskTypes: [TwitterQueueEnum.PUBLIC_REPLIES],
      },
    ];
  }

  getTaskTypeString(taskType: number): string {
    const mapping = {
      [TwitterQueueEnum.PRIVATE]: 'twitter/private',
      [TwitterQueueEnum.MENTION]: 'twitter/mention',
      [TwitterQueueEnum.PUBLIC_REPLIES]: 'twitter/public-replies',
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType: number): string {
    const mapping = {
      [TwitterQueueEnum.PRIVATE]: 'tw-private',
      [TwitterQueueEnum.MENTION]: 'tw-mention',
      [TwitterQueueEnum.PUBLIC_REPLIES]: 'public-replies',
    };
    return mapping[taskType];
  }

  taskTypeHasPublicationFilter(taskType: number): boolean {
    return taskType === TwitterQueueEnum.MENTION;
  }

  taskTypeHasMentionFilter(taskType) {
    return taskType === TwitterQueueEnum.MENTION;
  }

  taskTypeHasPublicRepliesFilter(taskType) {
    return taskType === TwitterQueueEnum.PUBLIC_REPLIES;
  }

  getQuickRepliesElementsConfig(): QuickRepliesElementsConfiguration {
    return {
      maxAnswerNb: 20,
      answerLabelMaxLength: 36,
      hasDescription: true,
      canHaveUserVariableInRootQuestion: false,
      hasPhoneEmailAnswerType: false,
      hasUrlAnswerType: false,
      hasTargetAppId: false,
      boxesCanBeTested: false,
      hasPersistentMenu: false,
      hasWelcomeMessage: false,
      imageMimeTypes: 'image/*',
      editorConfiguration: {
        fileEnabled: false,
        hasImageControl: false,
      },
      sendTextAfterButtonChoice: false,
      canSendVideo: true,
    };
  }

  externalInboxURL(site): string {
    if (site.authorized_user && site.authorized_user.external_id) {
      return `https://twitter.com/messages/compose?recipient_id=${site.authorized_user.external_id}`;
    }
    return null;
  }

  mustCheckIfMessageDeleted(isPrivate: boolean): boolean {
    // Check if message is deleted if it is public
    return !isPrivate;
  }

  mustFetchContext(isPrivate): boolean {
    return !isPrivate;
  }

  handlesPublish(): boolean {
    return true;
  }

  /**
   * task.message.from.details.profile-id contains the channel username
   * ex: @toto for twitter
   */
  displayProfileId(): boolean {
    return true;
  }

  isQuickReplyEnable() {
    return 0;
  }
}
